import { useAppSelector } from 'app/state'
import { AccountPlan } from 'features/account/types'
import { LogInProviders } from '../types'

function useIsIndividualUser(): boolean {
  const me = useAppSelector((state) => state.users?.me)
  const account = useAppSelector((state) => state.account?.data)
  const userIsStudent = Boolean(me?.identities?.some((identity) => identity.provider === LogInProviders.GitHub))
  const userHasIndividualPlan = account.plan?.name === AccountPlan.Individual

  const isIndividual = userIsStudent || userHasIndividualPlan

  return isIndividual
}

export default useIsIndividualUser
